import { TriggerType } from "../interfaces/flow/trigger/TriggerType";

export const triggerByType = (trigger) => {
  switch (trigger.type) {
    case TriggerType.ATLASSIAN_WEBHOOK_TRIGGER_TYPE:
      return "Atlassian";
    case TriggerType.CUSTOM_WEBHOOK_TRIGGER_TYPE:
      return "Webhook";
    case TriggerType.SCHEDULED_TRIGGER_TYPE:
      return "Scheduled";
    default:
      return "Unknown";
  }
};
